module.exports = "/shared/img/hr-grey-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/hr-grey-btn.png
// module id = 2
// module chunks = 13